<template>
  <section page-gate>
    <div class="container">
      <div class="flex min-h-96 justify-center items-center flex-col gap-5">
        <h1 class="section-title text-3xl" v-text="pageStore?.page?.name"></h1>
        <template v-if="forbidden">
          <h2 class="section-lead">Access Forbidden</h2>
          <p class="section-description">Please use a valid Google Account</p>
          <p class="section-description">
            <a href="refresh" @click.prevent="refresh" class="btn btn-primary btn-sm">Login</a>
          </p>
        </template>
        <div v-else class="block">
          <GoogleSignInButton :one-tap="true" :auto-select="autoLogin" context="signin" @success="handleLoginSuccess" @error="handleLoginError"></GoogleSignInButton>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import type { CredentialResponse } from "vue3-google-signin";
  import { decodeCredential } from "vue3-google-signin";
  import { useAuthStore } from "@/stores/auth";

  const { getItem, setItem } = useLocalStorage();
  const authStore = useAuthStore();
  const pageStore = usePageStore();
  const forbidden = ref(false);
  const autoLogin = ref(false);

  const domainWhitelist = ["kudosity.com", "kudosity.co", "burstsms.com"];

  const emit = defineEmits(["authenticated"]);

  const refresh = () => {
    window.location.reload();
  };

  const handleLoginSuccess = (response: CredentialResponse) => {
    const { credential } = response;
    if (credential) {
      const decodedCredential = decodeCredential(credential);
      console.log("User:", decodedCredential);

      if (!domainWhitelist.includes(decodedCredential?.hd)) {
        forbidden.value = true;
        return;
      }

      authStore.setToken(credential);
      authStore.setUser(decodedCredential);

      setItem("kudonauts",[decodedCredential.id,decodeCredential?.iat,decodeCredential?.exp].join('-'));

      emit("authenticated", true);
    }
  };

  // handle an error event
  const handleLoginError = () => {
    console.error("Login failed");
  };

  onMounted(() => {
    if (authStore.isAuthenticated() === true) {
      emit("authenticated", true);
    }
  });
</script>
